module.exports = __webpack_public_path__ + "static/media/newkatalog.bc0a6222.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newkatalog.mp4
// module id = 310
// module chunks = 0